import React, { useEffect, useState } from "react";
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useLocation } from "react-router-dom";
import { PageActionPermission } from "services/pageActionPermission/PageActionPermission";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('component_reason_prompt_modal');

interface ReasonPromptModalProps {
  isOpen: boolean;
  title: string;
  label?: string;
  confirmLabel: string;
  confirmColor?: string;
  minLength?: number;
  submitting?: boolean;
  onSubmit: (reason: string) => void | Promise<void>;
  onCancel: () => void;
}

// Popup nhap ly do dung chung cho moi thao tac "Huy" can bat buoc giai thich (Huy ke hoach, Huy
// tao ve, Huy xuat vé, Huy xuat anh QR) — tach ra tu modal "Huy ke hoach" goc trong
// pages/IssuancePlan/index.tsx de tai su dung o 4 noi thay vi lap lai modal.
const ReasonPromptModal: React.FC<ReasonPromptModalProps> = ({
  isOpen,
  title,
  label = st('ly_do_text'),
  confirmLabel,
  confirmColor = "danger",
  minLength = 5,
  submitting = false,
  onSubmit,
  onCancel,
}) => {
  const [reason, setReason] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (isOpen) setReason("");
  }, [isOpen]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (reason.trim().length < minLength) {
      return;
    }
    onSubmit(reason.trim());
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered>
      <ModalHeader className="bg-light p-3" toggle={onCancel}>
        {title}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>{label}</Label>
            <Input
              type="textarea"
              rows={4}
              required
              minLength={minLength}
              value={reason}
              data-action-code="input-reason"
              data-action-name="Lý do"
              onChange={(event) => setReason(event.target.value)}
              autoFocus
              disabled={!PageActionPermission.canEnable(location.pathname, "input-reason")}
            />
          </FormGroup>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <Button color="light" onClick={onCancel} disabled={submitting}>
              {st('dong_button')}
            </Button>
            {PageActionPermission.canDisplay(location.pathname, "button-reason-confirm") && (
              <Button
                color={confirmColor}
                type="submit"
                data-action-code="button-reason-confirm"
                data-action-name="Xác nhận (kèm lý do)"
                disabled={submitting}
              >
                {submitting && (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                )}
                {confirmLabel}
              </Button>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ReasonPromptModal;
